import _extends from 'babel-runtime/helpers/extends';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { Loading } from 'element-ui';

export default {
  data: function data() {
    return {
      navIndexChild: 0
    };
  },

  props: {
    navIndex: {
      type: [Number, String],
      default: 0
    }
  },
  components: {},
  computed: _extends({}, mapGetters(['userInfo', 'lang', 'logo', 'navList'])),
  mounted: function mounted() {
    this.navIndexChild = this.navIndex;
  },

  methods: {
    navItemsClick: function navItemsClick(type) {
      //console.log(type)
      this.navIndexChild = type;
      this.$store.commit('SET_NAVACTIVEINDEX', type);
    },
    handleClick: function handleClick(type) {
      var _this = this;

      if (type === 'goout') {
        //退出系统
        this.$confirm('退出登录？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          var loading = Loading.service({
            target: document.getElementById('#app')
          });
          _this.$store.dispatch('LogOut').then(function () {
            location.reload();
            loading.close();
          }).catch(function () {
            location.reload();
            loading.close();
          });
        }).catch(function () {});
      } else if (type === 'person') {
        //去个人中心
        this.$router.push({
          name: 'person'
        });
      } else if (type === 'CTJR') {
        window.open("https://www.changtaojinrong.com/qydcms/login");
        //window.location.href= 'https://www.changtaojinrong.com/qydcms/login';
      } else if (type === 'CTXD') {
        window.open("https://scm.ctwlxiaodai.com/index");
      } else if (type === 'CTFD') {
        window.open("https://fangdi.ctwlxiaodai.com/");
      }
    }
  }
};